import { ChangeEvent, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    ClearInputIcon,
    INPUT_FIELD_SIZES
} from "components/DesignComponents/InputField";
import InputFieldWithDropdown from "components/DesignComponents/InputFieldWithDropdown";

import { NAME } from "./constants";
import ListCompanies from "./ListCompanies";

const CompanySelector = () => {
    const { t } = useTranslation();

    const [searchValue, setSearchValue] = useState("");

    const handleSearchValue = (e: ChangeEvent<HTMLInputElement>) =>
        setSearchValue(e.target.value);

    const clearSearchValue = () => setSearchValue("");

    return (
        <>
            <div
                css={css({
                    padding: "12px 16px"
                })}
            >
                <InputFieldWithDropdown
                    autoFocus
                    fullWidth
                    size={INPUT_FIELD_SIZES.Medium}
                    placeholder={t("Search##search by")}
                    value={searchValue}
                    onChange={handleSearchValue}
                    onKeyDown={e => e.stopPropagation()} // prevents from losing focus on pressing "c" key
                    iconRight={
                        <ClearInputIcon
                            value={searchValue}
                            clearValue={clearSearchValue}
                        />
                    }
                    dropdownList={[{ value: NAME, name: NAME }]}
                    inputCustomStyle={{ padding: "11px 12px" }}
                />
            </div>

            <ListCompanies searchValue={searchValue} />
        </>
    );
};

export default CompanySelector;
